import './App.css';
// import './styles/estiloModel.css';

import { useState } from "react";

import Button from 'react-bootstrap/Button';

import {RiWhatsappFill} from 'react-icons/ri';

import Inicio from "./elements/Inicio";
import Sobremi from "./elements/Sobremi";
import Servicios from "./elements/Servicios";

import Contacto from "./elements/Contacto";

import CompraOnlineSection  from "./elements/CompraOnlineSection";
import Pago from "./elements/Pago";

import Footer from "./elements/Footer";


const estiloWapp = {
	fontSize: '52px',
	marginTop: '0',
	marginLeft: '0',
	color: 'green'
}


function App() {
/*
  const TikTokIcon = ({ color = "#fff", sx = {} }) => {
    return (
      <Box
        component="svg"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 50 50"
        sx={{ width: "1.5em", height: "1.5em", fill: color, ...sx }}
      >
        <path d="M41,4H9C6.243,4,4,6.243,4,9v32c0,2.757,2.243,5,5,5h32c2.757,0,5-2.243,5-5V9C46,6.243,43.757,4,41,4z M37.006,22.323 c-0.227,0.021-0.457,0.035-0.69,0.035c-2.623,0-4.928-1.349-6.269-3.388c0,5.349,0,11.435,0,11.537c0,4.709-3.818,8.527-8.527,8.527 s-8.527-3.818-8.527-8.527s3.818-8.527,8.527-8.527c0.178,0,0.352,0.016,0.527,0.027v4.202c-0.175-0.021-0.347-0.053-0.527-0.053 c-2.404,0-4.352,1.948-4.352,4.352s1.948,4.352,4.352,4.352s4.527-1.894,4.527-4.298c0-0.095,0.042-19.594,0.042-19.594h4.016 c0.378,3.591,3.277,6.425,6.901,6.685V22.323z" />
      </Box>
    );
  };
*/
const envioWapp = () => {
		const url = 'https://wa.me/5491156269545?text=Quisiera%20contactarme%20por%20sus%20servicios';
		window.open(url, '_blank');

	};
  
  const telefono = "5491123456789"; 
  const whatsappMsg = "Hola Vicky, quiero hacer una consulta sobre Tarot Angélico";

  const [menuOpen, setMenuOpen] = useState(false);
  const [active, setActive] = useState("inicio");

const handleClick = (id) => {
  setActive(id);
  setMenuOpen(false);
};

  return (
    <div className="App">
      {/* NAVBAR */}
      <header className="header">
        <nav className="navbar">
          <div className="logo">
          <img src="./images/logo_gral_negro.png" alt="Logo Vicky" className="logo-img" />
        </div>

          <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
            <li>
              <button
                className={active === "inicio" ? "active" : ""}
                onClick={() => handleClick("inicio")}
              >
                Inicio
              </button>
            </li>
            <li>
              <button
                className={active === "sobremi" ? "active" : ""}
                onClick={() => handleClick("sobremi")}
              >
                Sobre mí
              </button>
            </li>
            <li>
              <button
                className={active === "servicios" ? "active" : ""}
                onClick={() => handleClick("servicios")}
              >
                Servicios
              </button>
            </li>
            <li>
              <button
                className={active === "pago" ? "active" : ""}
                onClick={() => handleClick("pago")}
              >
                Formas de Pago
              </button>
            </li>
            <li>
              <button
                className={active === "contacto" ? "active" : ""}
                onClick={() => handleClick("contacto")}
              >
                Contacto
              </button>
            </li>
            <li>
              <button
                className="btn-consulta"
                onClick={() =>
                  window.open(
                    `https://wa.me/${telefono}?text=${encodeURIComponent(whatsappMsg)}`,
                    "_blank"
                  )
                }
              >
                Consultame
              </button>
            </li>
          </ul>

          <div
            className={`hamburger ${menuOpen ? "toggle" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <div className="line1"></div>
            <div className="line2"></div>
            <div className="line3"></div>
          </div>
        </nav>


      </header>

      {/* Secciones */}
<div className="seccion-contenido">
  {active === "inicio" && <Inicio />}
  {active === "sobremi" && <Sobremi />}
  {active === "servicios" && <Servicios />}
  {active === "pago" && <Pago />}
  {active === "contacto" && <Contacto />}
</div>


      <div >
        <Footer />
      </div>

      <Button   onClick={envioWapp}  className="botonWhatsapp  mx-auto">
        <RiWhatsappFill style={estiloWapp}/> 
      </Button>
    </div>
  );
}

export default App;

